import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListIsLockedCell } from './charge-point-list-is-locked.cell';
import { ChargePointListIsLockedHeader } from './charge-point-list-is-locked.header';

export const ChargePointListIsLockedColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['isLocked']
> = {
  enableSorting: false,
  header: ChargePointListIsLockedHeader,
  cell: ChargePointListIsLockedCell,
};
